<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline">
                    <button type="button" class="btn btn-warning"
                            @click="showSheetType(null)">
                        <icon name="plus"></icon>
                        เพิ่มวัตถุดิบ
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive" >
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ประเภทวัตถุดิบ</th>
                    <th scope="col">วันที่เพิ่ม</th>
                    <th scope="col">แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in material_type">
                    <td>{{++index}}</td>
                    <td>{{data.name}}</td>
                    <td>{{data.created_at | moment("DD/MM/YYYY")}}</td>
                    <td>
                        <a @click="showSheetType(data)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-header hide-footer ref="sheet_type">
            <material-type-modal @submit="saveMaterialType" :form="form">
            </material-type-modal>
        </b-modal>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import MaterialTypeModal from "./MaterialTypeModal";
    export default {
        name: "MaterialTypeList",
        components: {MaterialTypeModal},
        created() {
            this.getMaterialTypeList();
        },
        computed: {
            ...mapState({
                material_type : state=>{
                    return state.Common.material_type
                }
            })
        },
        data(){
          return{
              form : {
                  id : '',
                  name : '',
              }
          }
        },
        methods:{
            getMaterialTypeList(){
                this.$store.dispatch("Common/getMaterialType");
            },
            showSheetType(data){
                if(data){
                    this.form = data;
                }
                this.$refs.sheet_type.show();
            },
            hideSheetType(){
                this.$refs.sheet_type.hide();
            },
            saveMaterialType(value){
                if(value){
                    this.$store.dispatch("Material/saveMaterialType",value).then(()=>{
                        this.getMaterialTypeList();
                    });
                }
                this.hideSheetType();
                this.form = {
                    id : '',
                    name : '',
                }
            } ,
        },
    }
</script>

<style scoped>

</style>
